import Vue from 'vue';
import axios from 'axios';

const host = window.location.host;

export default new Vue({
  data(){
    return {
      browse: {
        category: [],
        categoryAR: [],
        categoryMY: []
      },
      main: {
        hotpicks: {},
        category: {},
        isLoad: false
      },
      search: {
        allSearch: {}
      },
      type: 'browse'
    }
  },
  created(){
    if(host.includes("apps4all")){
      this.getBrowse();
      // this.getHotPicks();
    }
  },
  methods: {
    async getHotPicks(browseCate) {
      let isload = '';
      let browseCat = [];
      let browseCategory = [];
      let allDataContent = [];
      let allData = [];
      
      let live = `http://cook.grabmobi.com`
      let local = `http://[::1]/PuretechGlobalContentPortal`
      
      //get subcategory under game
      let browse = await axios.get(
          `${live}/api/contents/app4all?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=10&offset=0&domain=${host}`
      );
      let temp = []
      let browseSort = browseCate.filter((item)=>{
          if(item.category == 'Application'){
              temp = item;
          }else{
          return item;
          }
      })
      if(temp != ''){
          browseSort.push(temp);
      }

      browseCat = browseSort;
      // browseCat.map((item)=>{
      // let trans = JSON.parse(item.category_translate);
      // if (trans != null) {
      //     let trans_len = Object.keys(trans).length;
      //     let trans_arr = Object.keys(trans);
      //     for (let i = 0; i < trans_len; i++) {
      //         item["title_" + trans_arr[i]] = trans[trans_arr[i]].title;
      //     }
      // }
      //     browseCategory.push(item)
      // })
      
      //get random number
      var oneHourInMs = 3600000;
      var currentTimeInMs = new Date().getTime();  // UTC time
      var timeInHour = Math.floor(currentTimeInMs / oneHourInMs);
      var numberForToday = timeInHour % 18;
      // zero-filling of numbers less than four digits might be optional for you
      // zero-filled value will be a string to maintain its leading 0s
      var DigitNumber = numberForToday.toString();
      while(DigitNumber.length < 2)
      {
        DigitNumber = 0+Number(DigitNumber);
      }

      for(let i =0 ; i<browseCat.length; i++ ){
          allData = await axios.get(
          `${live}/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=${browseCat[i].category}&limit=100&offset=0&domain=${host}`
          );
          
          let divide = DigitNumber % 2;
          if(divide == 0){
            allData.data.data.sort((a, b) => {
              //to sort random
              return Math.random()-0.5;
            });
          }else{
            allData.data.data.sort((a, b) => {
              //to sort random
              return 0.5 - Math.random();
            });
          }

        let data_slice = allData.data.data.slice(0,6)
        let categ = browseCat[i].category
        allDataContent[categ] = new Array();
        allDataContent[categ] = data_slice;
      }

      isload = true;

      this.main.hotpicks = allDataContent;
      this.main.category = browseCat;
      this.main.isLoad = isload;
  },
  getBrowse(){
    let local = `http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=100&offset=0&domain=${host}`
    let live = `http://cook.grabmobi.com/api/contents/app4all?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=100&offset=0&domain=${host}`;
        
    axios.get(live).then(res => 
    {
      let data = res.data.data
      let temp = []
      
      data.map(item=>{
          item.title_english = item.category
          item.route = item.title_english.toLowerCase()
          
          let trans = JSON.parse(item.category_translate)
          let icon = JSON.parse(item.category_icon)
          
          if(trans != null){
              let trans_len = Object.keys(trans).length
              let trans_arr = Object.keys(trans)
              for(let i = 0; i<trans_len; i++){
                  item['title_'+trans_arr[i]] = trans[trans_arr[i]].title
              }
              // item.icon = icon['my.1.grabmobi.com']['class'];
          }
          
          if(icon != null){
              for (let [key, value] of Object.entries(icon)) {
                  if (key == host) {
                      item.icon = icon[key]["class"];
                  }else{
                      item.icon = icon['mobizone.vip']['class'];
                  }
              }
          }

          item.coverImg = require(`../../../assets/funplus/imgs/browse/${item.category}.jpg`)

          temp.push(item)
      })
      
      let item_temp = temp.map(function(v) { 
          delete v.category_translate; 
          delete v.category_translate; 
          delete v.category_icon; 
          delete v.subcategory; 
          delete v.subcategory_translate;
          delete v.subcategory_icon;
          delete v.thumbnail_url;
          delete v.cover_img;
          return v; 
      });
      
      this.browse.category = item_temp
      this.getHotPicks(item_temp);
    })

    }
  }
})


// WEBPACK FOOTER //
// ./src/components/apps4all/apps4all-js/apps4all.js